document.addEventListener('DOMContentLoaded', function () {
  var video = document.getElementById('syra-intro-video');
  if (!video) return;

  // Extra zekerheid: forceer muted ook via JS, sommige browsers negeren
  // het HTML-attribuut als het te laat in de DOM verschijnt.
  video.muted = true;
  video.setAttribute('muted', '');
  video.playsInline = true;

  function tryPlay() {
    var playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(function () {
        // Autoplay geblokkeerd — probeer opnieuw zodra de gebruiker ergens
        // op de pagina tikt of scrollt (telt als interactie voor de browser).
        var retry = function () {
          video.play();
          document.removeEventListener('touchstart', retry);
          document.removeEventListener('click', retry);
          document.removeEventListener('scroll', retry);
        };
        document.addEventListener('touchstart', retry, { once: true });
        document.addEventListener('click', retry, { once: true });
        document.addEventListener('scroll', retry, { once: true });
      });
    }
  }

  // Probeer direct te spelen zodra de pagina klaar is
  tryPlay();

  // En probeer opnieuw zodra de video daadwerkelijk in beeld scrollt
  // (belangrijk als de sectie niet meteen boven in het scherm staat)
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          tryPlay();
        }
      });
    }, { threshold: 0.25 });

    observer.observe(video);
  }
});
